import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Cross-cutting kiosk session signals shared between the kiosk shell and the
 * customer-facing pages it hosts.
 *
 * Today it carries a single event: a request to reset the flow back to a clean
 * "attract" state. The idle screensaver fires this when a new customer wakes
 * the panel, so the next walk-up never inherits the previous person's
 * half-built quote.
 */
@Injectable({ providedIn: 'root' })
export class KioskSessionService {
    private readonly _reset$ = new Subject<void>();

    /** Emits whenever a hosted kiosk page should reset itself for a new customer. */
    get reset$(): Observable<void> {
        return this._reset$.asObservable();
    }

    /** Ask any listening kiosk page to reset to its welcome/attract state. */
    requestReset(): void {
        this._reset$.next();
    }
}
